// Helper function to convert PascalCase to camelCase
const toCamelCase = (str: string): string => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

// Helper function to recursively convert object keys from PascalCase to camelCase
const convertKeysToCamelCase = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(convertKeysToCamelCase);
  }

  if (typeof obj === 'object' && obj.constructor === Object) {
    const converted: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const camelKey = toCamelCase(key);
        converted[camelKey] = convertKeysToCamelCase(obj[key]);
      }
    }
    return converted;
  }

  return obj;
};

export const parseJson = (
  json: string | undefined | null,
  defaultValue: any,
  shouldConvertKeysToCamelCase = false,
) => {
  if (!json) {
    return defaultValue;
  }
  try {
    const parsed = JSON.parse(json);
    if (!shouldConvertKeysToCamelCase) {
      return parsed;
    }
    return convertKeysToCamelCase(parsed);
  } catch (error) {
    return defaultValue;
  }
};

export const downloadFileBlob = (file: Blob, fileName: string) => {
  const href = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export function deepCopy<T>(obj: T) {
  return JSON.parse(JSON.stringify(obj)) as T;
}

// converts a Date object to a UTC ISO string at noon (12:00:00.000Z)
export function toUTCNoonISOString(date: Date | null) {
  if (!date) return null;

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  const utcDate = new Date(Date.UTC(year, month, day, 12, 0, 0));
  return utcDate.toISOString();
}

/**
 * Returns the thrown error if `json` is not valid JSON, or `null` if it parses.
 * Shared by the rule/formula JSON editors for inline validation.
 */
export const getParsedJsonError = (json: string) => {
  try {
    JSON.parse(json);
    return null;
  } catch (error) {
    return error;
  }
};
